import { Link } from "react-router-dom";

export default function Logo({ to = "/", className = "" }) {
  return (
    <Link
      data-testid="brand-logo"
      to={to}
      className={`inline-flex items-center gap-2.5 ${className}`}
    >
      <span className="relative inline-flex items-center justify-center w-8 h-8 rounded-lg bg-primary text-primary-foreground font-display font-bold text-sm shadow-md">
        IG
        <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-accent ring-2 ring-background animate-pulse-soft" />
      </span>
      <span className="font-display font-semibold text-[17px] tracking-tight text-foreground">
        Insure<span className="text-secondary">Genie</span>
      </span>
    </Link>
  );
}
